import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

declare let __twingle_products: any;

@Injectable({
    providedIn: 'root',
})
export class ShopProductService {
    // We can use a simple boolean here, because these variables are not changed on user input
    private decimalsShownList: boolean = false;
    private decimalsShownDetails: boolean = false;

    // We need a BehaviorSubject here, because the some components are not reloaded when the setting is changed
    private decimalsShownCart$ = new BehaviorSubject<boolean>(false);

    constructor() {
        // if any product has a price with decimals, show them everywhere
        if (typeof __twingle_products !== "undefined" && __twingle_products.length > 0) {
            __twingle_products.forEach(productData => {
                if (productData.price && productData.price % 1 !== 0) {
                    this.decimalsShownList = true;
                    this.decimalsShownDetails = true;
                    this.decimalsShownCart$.next(true);
                }
            });
        }
    }

    /** 
     * Get if decimals should be shown in the list
     */
    getDecimalsShownList(): boolean {
        return this.decimalsShownList;
    }

    /** 
     * Get if decimals should be shown on the details page
     */
    getDecimalsShownDetails(): boolean {
        return this.decimalsShownDetails;
    }

    /** 
     * Get if decimals should be shown in the cart
     */
    getDecimalsShownCart(): Observable<boolean> {
        return this.decimalsShownCart$.asObservable();
    }

    /**
     * Set if decimals should be shown in the cart
     */
    setDecimalsShownCart(value: boolean) {
        this.decimalsShownCart$.next(value);
    }    
}